// @flow

import * as React from 'react';
import { Cookies, withCookies } from 'react-cookie';
import { I18n } from 'react-redux-i18n';
import { cookieDefaultDate } from "../../const";

type Props = {
  cookieToSet: string,
  title: string,
  leftValue: string,
  rightValue: string,
  cookies: Cookies,
}

type State = {
  isFra: boolean,
}

class CookieSwitchSelector extends React.Component<Props, State> {
  state: State = {
    isFra: this.props.cookies.get(this.props.cookieToSet) === 'm',
  };

  handleClick = () => {
    this.setState(
      {
        isFra: !this.state.isFra,
      },
      () => this.props.cookies.set(
        this.props.cookieToSet,
        this.state.isFra ? this.props.leftValue : this.props.rightValue,
        { expires: cookieDefaultDate, path: '/' },
      ),
    );
  };

  shouldComponentUpdate(nextProps: Props, nextState: State): boolean {
    if ((nextProps.cookies.get(nextProps.cookieToSet) === 'm') !== this.state.isFra) {
      nextState.isFra = nextProps.cookies.get(nextProps.cookieToSet) === 'm';
    }
    return true;
  }

  render() {
    return (
      <div
        className="selector"
      >
        {this.props.title}
        <div className="switch-container">
          <p>{I18n.t(`SIDE_MENU.${this.props.leftValue}`)}</p>
          <label id="switch" htmlFor="switch-input" className="switch">
            <button
              id="switch-input"
              className={`slider round ${this.state.isFra ? '' : ' right'}`}
              onClick={this.handleClick}
            />
          </label>
          <p>{I18n.t(`SIDE_MENU.${this.props.rightValue}`)}</p>
        </div>
      </div>
    );
  }
}

export default withCookies(CookieSwitchSelector);
